import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Container, Button, Row, Col, Spinner } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faInfo,
    faEdit,
    faTrash,
    faUserPlus,
} from "@fortawesome/free-solid-svg-icons";
//import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';


import paginationFactory from "react-bootstrap-table2-paginator";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import swal from 'sweetalert';
import { deleteAlumno } from "./AlumnoAction";
import { withRouter } from 'react-router-dom';


const { SearchBar } = Search;

const defaultSorted = [
    {
        dataField: "idalumno",
        order: "asc",
    },
];

const mapStateToProps = (state) => {
    //console.log("Javier -------> Se carga TableComponent|MapStateToProps ");

    return {
        getAlumnoList: state.AlumnoReducer.getAlumnoList,
        errorAlumnoList: state.AlumnoReducer.errorAlumnoList,
        getAlumnoBorrar: state.AlumnoReducer.getAlumnoBorrar,
        errorAlumnoBorrar: state.AlumnoReducer.errorAlumnoBorrar,
    };

};

function columnFormatter(cell, row) { return (<span className="font-12">{cell}</span>); }

function headFormatter(column, colIndex) { return (<strong >{column.text}</strong>); }


const AlumnoEnPagosTabla = (props) => {
    //console.log("Javier -------> Se carga TableComponent | PROPS");


    //Idtutor

    const columns = [
        {
            dataField: "idalumno",
            text: "ID",
            sort: true,
            headerStyle: () => {
                return { width: "5%", color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "apellidopaterno",
            text: "Apellido Paterno",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "apellidomaterno",
            text: "Apellido Materno",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "nombres",
            text: "Nombres",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "nivel",
            text: "Nivel",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "nivel2",
            text: "Grado",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "grupo",
            text: "Grupo",
            sort: true,
            headerStyle: () => {
                return { color: "black" };
            },
            formatter: columnFormatter,
            headerFormatter: headFormatter
        },
        {
            dataField: "link",
            text: "",
            formatter: (rowContent, row) => {
                return (
                    <div>
                        {/*
                        <Link to={"cobroenpagosservicioalumno/" + row.idalumno}>
                            <button type="button" className="btn btn-icon btn-sm" title="Pago Servicios En Pagos"><i className="fa fa-user-plus"></i></button>
                        </Link>
                        */}

                        <Link to={"cobroenpagosalumno/" + row.idalumno}>
                            <button type="button" className="btn btn-icon btn-sm" title="Pago Colegiatura En Pagos"><i className="fa fa-credit-card"></i></button>
                        </Link>

                    </div>
                );
            },
        },
    ];


    var total = props.getAlumnoList.length;

    return (

        <Container>

            {
                props.getAlumnoList ? (
                    <ToolkitProvider
                        bootstrap4
                        keyField="idalumno"
                        data={props.getAlumnoList}
                        columns={columns}
                        defaultSorted={defaultSorted}
                        search
                    >
                        {(props) => (
                            <div>
                                <Row>
                                    <Col>
                                        <div className="float-right">
                                            <SearchBar {...props.searchProps} placeholder="Buscar En Lista .." />
                                        </div>
                                    </Col>
                                </Row>

                                <BootstrapTable
                                    keyField="idalumno"
                                    {...props.baseProps}
                                    pagination={paginationFactory(
                                        {
                                            showTotal: true, // display pagination information
                                            sizePerPageList: [
                                                {
                                                    text: '50', value: 50
                                                },
                                                {
                                                    text: '100', value: 100
                                                },
                                                {
                                                    text: 'Todos', value: total
                                                }
                                            ],
                                            firstPageText: 'Primero', // the text of first page button
                                            prePageText: 'Previo', // the text of previous page button
                                            nextPageText: 'Siguiente', // the text of next page button
                                            lastPageText: 'Ultimo', // the text of last page button
                                            nextPageTitle: 'Ir Siguiente', // the title of next page button
                                            prePageTitle: 'Ir Previo', // the title of previous page button
                                            firstPageTitle: 'Ir Primero', // the title of first page button
                                            lastPageTitle: 'Ir Ultimo', // the title of last page button
                                        }
                                    )
                                    }
                                />
                            </div>
                        )}
                    </ToolkitProvider>
                ) :
                (
                    <div className="text-center">
                        {props.errorAlumnoList ? (
                            <h4>{props.errorAlumnoList}</h4>
                        ) : (
                                <Spinner color="dark" />
                            )}
                    </div>
                )
           }
        </Container>

    );
};

export default withRouter(connect(mapStateToProps, null)(AlumnoEnPagosTabla));

